import moment from 'moment';
import { AxiosPromise } from 'axios';

import { ApiService } from 'app/services/api.service';

const DATE_FORMAT = 'DD.MM.YYYY';

export function getFormattedDate(date?: string): string {
  return moment(date).format(DATE_FORMAT);
}

export function getDateFromServer(): AxiosPromise<string> {
  return ApiService.get(`dictionaries/currentDateTime?a=${moment()}`);
}
